// @flow
import {PureComponent} from 'react';
import PropTypes from 'prop-types';

/* global google */

export default class Circle extends PureComponent {
    static propTypes = {
        /** Unique identifier for the circle */
        id: PropTypes.string.isRequired,
        /** Reference to the map (injected by default if wrapped in GoogleMap component) */
        map: PropTypes.object, // eslint-disable-line react/forbid-prop-types
        /** Callback for clicking on the circle */
        onClick: PropTypes.func,
        /** Stroke color of the outer radius */
        strokeColor: PropTypes.string,
        /** Stroke opacity of the outer radius */
        strokeOpacity: PropTypes.number,
        /** Stroke weight of the outer radius */
        strokeWeight: PropTypes.number,
        /** Fill color of the inner circle */
        fillColor: PropTypes.string,
        /** Fill opacity of the inner circle */
        fillOpacity: PropTypes.number,
        /** Center of the circle */
        center: PropTypes.shape({
            lat: PropTypes.number.isRequired,
            lng: PropTypes.number.isRequired,
        }).isRequired,
        radius: PropTypes.number.isRequired,
    };

    static defaultProps = {
        onClick: /* istanbul ignore next */ () => {},
        fillColor: '#0067db', // @ha-core-blue
        fillOpacity: 0.5,
        radius: 500,
        strokeWeight: 0,
    };

    constructor(props) {
        super(props);

        const {id, onClick, ...rest} = props;
        const circle = new google.maps.Circle(rest);

        google.maps.event.addListener(circle, 'click', () => {
            onClick(id);
        });

        this.circle = circle;
    }

    componentDidUpdate() {
        const {id, map, onClick, ...rest} = this.props; // eslint-disable-line no-unused-vars
        this.circle.setOptions(rest);
    }

    componentWillUnmount() {
        /* Remove all marker listeners */
        google.maps.event.clearInstanceListeners(this.circle);

        /* Remove circle */
        this.circle.setMap(null);
    }

    render() {
        return false;
    }
}
